<template>
  <custom-nuxt-link :to="banner.url" class="topBanner alignCenter">
    <picture>
      <source v-if="webpImage" :srcset="webpImage" type="image/webp" />
      <img :src="campaignBannerImage.url" :width="campaignBannerImage.width" :height="campaignBannerImage.height" :alt="banner.alt" />
    </picture>
  </custom-nuxt-link>
</template>
<script>
export default {
  props: {
    banner: { type: Object, required: true, default: null }
  },
  computed: {
    webpImage() {
      return this.$store.isPC ? this.banner.webpPcImage : this.banner.webpSpImage
    },
    campaignBannerImage() {
      return this.$store.isPC ? this.banner.pcImage : this.banner.spImage
    }
  }
}
</script>
<style lang="scss" scoped>
.topBanner {
  img {
    max-width: 100%;
    height: auto;
  }
}
</style>
